import * as React from "react";
import { SVGProps } from "react";

const Serum = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 251 283"
    {...props}
  >
    <linearGradient
      id="a"
      x1={125.5}
      x2={125.5}
      y1={52.088}
      y2={253.088}
      gradientTransform="matrix(1 0 0 -1 0 285.976)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#05aac5" />
      <stop offset={1} stopColor="#71e0ec" />
    </linearGradient>
    <path
      fill="url(#a)"
      d="M125.5 233.9c-43.1 0-78.1-35-78.1-78.1 0-41.9 70.7-115.9 73.7-119l3.7-3.9 3.8 3.8c3.1 3.1 75 77.1 75 119 0 43.2-35 78.2-78.1 78.2zM124.9 48c-6.2 6.7-19.2 21.2-32.1 38.2-22.9 30.2-35 54.2-35 69.5 0 37.3 30.4 67.7 67.7 67.7s67.7-30.4 67.7-67.7c0-15.3-12.3-39.3-35.6-69.5-13.1-16.9-26.4-31.5-32.7-38.2z"
    />
    <linearGradient
      id="b"
      x1={125.6}
      x2={125.6}
      y1={27.088}
      y2={269.363}
      gradientTransform="matrix(1 0 0 -1 0 285.976)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#05aac5" />
      <stop offset={1} stopColor="#71e0ec" />
    </linearGradient>
    <path
      fill="url(#b)"
      d="M125.5 258.9c-56.9 0-103.1-46.3-103.1-103.1 0-55.6 77.6-133.2 80.9-136.4 2-2 5.4-2 7.4 0s2 5.4 0 7.4c-.8.8-77.8 77.8-77.8 129 0 51.1 41.6 92.7 92.7 92.7s92.7-41.6 92.7-92.7c0-21-13.6-50-39.4-84.1-19.8-26.1-39.7-45.9-39.9-46.1-2.1-2-2.1-5.3 0-7.4 2-2.1 5.3-2.1 7.4 0 3.4 3.3 82.4 81.9 82.4 137.6-.2 56.8-46.4 103.1-103.3 103.1z"
    />
    <linearGradient
      id="c"
      x1={125.5}
      x2={125.5}
      y1={2.088}
      y2={285.976}
      gradientTransform="matrix(1 0 0 -1 0 285.976)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#05aac5" />
      <stop offset={1} stopColor="#71e0ec" />
    </linearGradient>
    <path
      fill="url(#c)"
      d="M125.5 283.9C56.3 283.9 0 227.6 0 158.4c0-28.6 14.4-63.8 42.7-104.5C63.6 23.9 84.1 2.5 85 1.6c2-2.1 5.3-2.1 7.4-.1s2.1 5.3.1 7.4c-.2.2-20.9 21.8-41.3 51.1-26.7 38.3-40.8 72.3-40.8 98.4 0 63.4 51.6 115.1 115.1 115.1s115.1-51.6 115.1-115.1c0-26.1-14.2-60.1-41.1-98.4C178.9 30.7 158 9.1 157.8 8.9c-2-2.1-2-5.4.1-7.4s5.4-2 7.4.1c3.5 3.6 85.7 89 85.7 156.8 0 69.2-56.3 125.5-125.5 125.5z"
    />
  </svg>
);

export default Serum;
